module.exports = __webpack_public_path__ + "static/media/edit-profile.628e09d4.svg";